<template>
  <div class="navbar-filters-part">
    <CasesFilters v-if="casesRouteNames.indexOf($route.name) != -1" />
    <OrdersFilters v-if="orderRouteNames.indexOf($route.name) != -1" />
    <ResultFilters v-if="resultRouteNames.indexOf($route.name) != -1" />
    <PhysicianFilters v-if="physicianRouteNames.indexOf($route.name) != -1" />
    <HospitalFilters v-if="hospitalRouteNames.indexOf($route.name) != -1" />
    <ApprovalPendingCasesFilters
      v-if="pendingCasesRouteNames.indexOf($route.name) != -1"
    />
    <QCChartFilters v-if="qcchartRouteNames.indexOf($route.name) != -1" />
    <SendOutsFilters v-if="sendOutRouteNames.indexOf($route.name) != -1" />
    <ReceivedSendOutsFilters
      v-if="receivedSendOutRouteNames.indexOf($route.name) != -1"
    />
    <ResultFileFilters
      v-if="resultFileViewProgressRouteNames.indexOf($route.name) != -1"
    />
    <UserAccountsFilters
      v-if="userAccountRouteNames.indexOf($route.name) != -1"
    />

    <ArchiveFilters v-if="archiveRouteNames.indexOf($route.name) != -1" />
    <LogsFilters v-if="logsRouterName.indexOf($route.name) != -1" />
    <LabdaqFilters v-if="labdaqRouteNames.indexOf($route.name) != -1" />
    <BilledFilters v-if="billedRouteNames.indexOf($route.name) != -1" />
    <BillingRuleBookFilter
      v-if="billingRuleBookRouteNames.indexOf($route.name) != -1"
    />
  </div>
</template>

<script>
import {
  isTypingOrOverlayOpen,
  getSwitchableTabs,
} from "@/mixins/keyboardShortcutGuards";
import CasesFilters from "@/components/navbarFilter/CaseFilter";
import OrdersFilters from "@/components/navbarFilter/OrderFilter";
import ResultFilters from "@/components/navbarFilter/ResultFilter";
import PhysicianFilters from "@/components/navbarFilter/PhysicianFilter";
import HospitalFilters from "@/components/navbarFilter/HospitalFilter";
import ApprovalPendingCasesFilters from "@/components/navbarFilter/ApprovalPendingCasesFilter";
import QCChartFilters from "@/components/navbarFilter/QCChartFilter";
import SendOutsFilters from "@/components/navbarFilter/SendOutsFilter";
import ReceivedSendOutsFilters from "@/components/navbarFilter/ReceivedSendOutsFilter";
import ResultFileFilters from "@/components/navbarFilter/ResultFilesFilter";
import UserAccountsFilters from "@/components/navbarFilter/UserAccountsFilter";
import ArchiveFilters from "@/components/navbarFilter/ArchiveFilter";
import LogsFilters from "@/components/navbarFilter/LogsFilter";
import LabdaqFilters from "@/components/navbarFilter/LabdaqFilter";
import BilledFilters from "@/components/navbarFilter/BilledFilter";
import BillingRuleBookFilter from "@/components/navbarFilter/BillingRuleBookFilter";

export default {
  components: {
    CasesFilters,
    OrdersFilters,
    ResultFilters,
    PhysicianFilters,
    HospitalFilters,
    ApprovalPendingCasesFilters,
    QCChartFilters,
    SendOutsFilters,
    ReceivedSendOutsFilters,
    ResultFileFilters,
    UserAccountsFilters,
    ArchiveFilters,
    LogsFilters,
    LabdaqFilters,
    BilledFilters,
    BillingRuleBookFilter,
  },
  data() {
    return {
      casesRouteNames: [
        "AllCases",
        "CaseView",
        "ActiveCases",
        "SamplesReceived",
        "PendingCases",
        "CompleteCases",
        "ArchiveCase",
        "Case-Information-Update",
        "Concurrent-Case-Information-Update",
        "NewReportCases",
        "EMRNotSend",
        "CriticalCases",
        "PendingCasesList",
        "RejectedCases",
        "ReleasePending",
        "ReplacedInsurance",
        "RequiresAttentionCases",
        "FaxNotSentCases",
        "FaxInProcessCases",
        "TatCrossedCases",
        "CrossLabRegisteredCases",
        "PriorityCases",
        "InsuranceExceptionCases"
      ],
      orderRouteNames: [
        "AllOrders",
        "ActiveOrders",
        "CompleteOrders",
        "ArchiveOrders",
        "Order-Information",
        "Edit-Order-Info",
        "PartialOrders",
        "RejectionOrders",
        "PendingOrders",
        "RequiresAttentionOrders",
        "CollectedSamplesOrders",
        "SampleAckOrders",
        "PartiallyRejectedOrders",
        "InsuranceOnHoldOrders",
        "AddOnTestsOrders",
      ],
      resultRouteNames: [
        "allResults",
        "ActiveResults",
        "ToStartResults",
        "CompleteResults",
        "ArchiveResults",
        "ProcessingResults",
        "FailedResults",
        "allResultsFileUpload",
      ],
      physicianRouteNames: [
        "AllPhysicians",
        "ActivePhysicians",
        "InActivePhysicians",
        "AddNewPhysician",
        "PhysicianProfileView",
        "PhysicianEdit",
      ],
      hospitalRouteNames: [
        "AllHospitals",
        "ActiveHospitals",
        "InActiveHospitals",
        "Hospital-Primary-Information",
        "NewHospital",
        "Branches-List",
        "HospitalPhysicians",
        "HospitalAccountManagers",
        "HospitalAdmins",
        "Add-Branch",
        "EditAccountManager",
        "EditHospitalAdmin",
        "Edit-Branch",
        "EditHospitalPhysician",
      ],
      userAccountRouteNames: [
        "userAccounts",
        "ActiveUserAccounts",
        "InActiveUserAccounts",
        "addUser",
        "EditUserAccount",
      ],
      pendingCasesRouteNames: [
        "AllApprovalPendingCases",
        "ActiveApprovalPendingCases",
        "PendingApprovalPendingCases",
        "CompleteApprovalPendingCases",
        "RejectedApprovalPendingCases",
        "PendingCaseView",
        "PendingCasesEdit",
      ],
      qcchartRouteNames: [
        "QCChatResults",
        "ToStartQCChartResults",
        "CompleteQCChartResults",
        "QCChartFileUpload",
      ],
      sendOutRouteNames: [
        "allSendOuts",
        "ActiveSendOuts",
        "PendingSendOuts",
        "CompleteSendOuts",
        "SendoutsInformation",
        "SendOutsEdit",
        "SendOutsView",
        "ArchiveSendouts",
        "AutoSendoutFailed",
      ],
      receivedSendOutRouteNames: [
        "allReceivedSendOuts",
        "ActiveReceivedSendOuts",
        "CompleteReceivedSendOuts",
        "ReceivedSendOutView",
      ],
      resultFileViewProgressRouteNames: [
        "viewprogress",
        "ToStartResultFilesViewProgress",
        "ProcessingResultFilesViewProgress",
        "FailedResultFilesViewProgress",
        "CompletedResultFiles",
      ],
      archiveRouteNames: ["ArchiveDataCases", "ArchiveDataOrders"],
      logsRouterName: [
        "casesLogs",
        "ordersLogs",
        "emrOrdersLogs",
        "resultFileLogs",
        "generalLogs",
        "loginLogs"
      ],

      labdaqRouteNames: [
        "LabdaqPendingOrders",
        "LabdaqPendingResults",
        "LabdaqInvalidOrders",
        "LabdaqCompletedOrders",
      ],
      billedRouteNames: [
        "AllPendingBilledCases",
        "BilledCases",
        "ClientBilledCases",
        "ExceptionBilledCases",
        "OnholdBilledCases",
        "BilledExceptionBilledCases",
        "BilledPatientBilledCases",
        "CodingCases",
        "MileageCases",
        "ExceptionResolvedCases",
        "ExceptionReviewedCases",
        "SelfPayCases",
        "SelfPayReviewedCases",
        "SelfPayStatementSentCases",
      ],
      billingRuleBookRouteNames: [
        "AllCodingRules",
        "AllClaim",
        "AllARRules",
        "PaymentRules",
        "PateintRules",
        "AddRules",
        "UpdatedRules",
      ],
    };
  },
  mounted() {
    window.addEventListener("keydown", this.onTabSwitchKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.onTabSwitchKeydown);
  },
  methods: {
    // Tab / Shift+Tab moves to the next / previous sub-tab (All, Active, ...) of
    // whichever list is open: cases, orders, sendouts, billing buckets and so on.
    // It stays out of the way while the user is typing or a dialog/menu is open,
    // and on pages that are not one of the tabs (case view, edit forms).
    // The keyboard icon in the top bar explains this to users.
    onTabSwitchKeydown(event) {
      if (event.key !== "Tab" || event.defaultPrevented) return;
      if (event.ctrlKey || event.metaKey || event.altKey) return;
      if (isTypingOrOverlayOpen(event.target)) return;

      const { links, currentIndex } = getSwitchableTabs();
      if (currentIndex === -1) return;

      event.preventDefault();
      const step = event.shiftKey ? -1 : 1;
      const next = links[(currentIndex + step + links.length) % links.length];
      next.click();
    },
  },
};
</script>

<style lang="scss">
.navbar-filters-part {
  .filters-list {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    margin-top: 0 !important;

    li {
      z-index: 999;
      flex-shrink: 0;

      &:not(:last-child) {
        margin-right: 5px;
        @media (min-width: 1200px) and (max-width: 1400px) {
          margin-right: 0;
        }
      }
    }
    a {
      color: #888383;
      font-weight: 500;
      font-size: 12px;
      display: block;
      white-space: nowrap;
      padding: 5px 7px;

      transition: all 0.2s ease-in-out;
      &:hover {
        color: #273480;
      }
      @media (min-width: 1200px) and (max-width: 1400px) {
        font-size: 13px;
        padding: 5px 8px;
      }
    }
    .active-icon {
      display: none;
    }

    // router-link-active
    .router-link-active,
    .router-link-active-parent > a {
      position: relative;
      color: #273480;
      opacity: 1;
      font-weight: 500;
      z-index: 1;
      .active-icon {
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        transform: translateX(40%);
        transition: all 5s ease;
        z-index: -1;
        img {
          margin-bottom: -13px;
        }
        img:first-child {
          margin-left: -2px;
        }
      }
    }
  }
}
</style>
